const DEFAULT_RULES = [
  {
    key: 1,
    state: true,
    label: 'Mínimo 8 caracteres',
    check: false,
    validate: (input: string) => Boolean(input && input.length >= 8)
  },
  {
    key: 2,
    state: true,
    label: 'Mínimo una mayúscula',
    check: false,
    validate: (input: string) => Boolean(input && input.match(/[A-Z]+/))
  },
  {
    key: 3,
    state: true,
    label: 'Mínimo una minúscula',
    check: false,
    validate: (input: string) => Boolean(input && input.match(/[a-z]+/))
  },
  {
    key: 4,
    state: true,
    label: 'Mínimo un caracter especial',
    check: false,
    validate: (input: string) => Boolean(input && input.match(/\W+/))
  },
  {
    key: 5,
    state: true,
    label: 'Mínimo un número',
    check: false,
    validate: (input: string) => Boolean(input && input.match(/[0-9]+/))
  }
]

export default DEFAULT_RULES
